<template>
    <div class="page">
        <img src="../../assets/images/acmedback.png" class="topimg" alt="">
        <div class="totle">
            <div class="maintitle">您提交的表格正在审核</div>
            <div class="maintitle">请耐心等待</div>
            
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    name: 'uploadInfo',
    data() {
        return {

        }
    },
    computed: {
    },
    created() {
        document.title = "加入ACMED";
    },
    beforeDestroy() {

    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.page {
    width: 100%;
    height: 100%;
    position: relative;
    background: rgb(247, 249, 253);
}

.totle {
    position: absolute;
    width: 100%;
    top: 30%;
    transform: translateY(-50%);
}

.maintitle {
    margin: auto;
    text-align: center;
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 1rem;
}

.okqrcode {
    display: block;
    margin: auto;
    width: 55%;
    margin-top: 1rem;
}

.maininner {
    width: 73%;
    margin: auto;
    font-size: 20px;
}

.topimg {
    width: 100%;
}
</style>